import type { LmsAirportFacet, LmsFilters } from '@/interfaces/lms';
import { updateListFilter } from '@/lib/utils/lmsQueryParams';
import displayValues from '@/resources/displayValues.json';
import { SimpleCheckboxFilter } from './checkbox/SimpleCheckboxFilter';

const originAirports: Record<string, string> = displayValues.originAirports;

type LmsOriginFilterProps = {
    data?: LmsAirportFacet[];
    filters: LmsFilters;
    updateFilters: (key: string, value: string[]) => void;
};

export const LmsOriginFilter = ({ data, filters, updateFilters }: LmsOriginFilterProps) => {
    const options = Object.keys(originAirports)
        .filter((iata) => iata !== '') // Remove "Alle flyplasser i Norge"
        .map((iata) => ({
            value: iata,
            text: originAirports[iata],
            count: data?.find((facet) => facet.name === iata)?.count ?? 0,
        }));

    const onChange = (value: string): void => {
        updateFilters('fra', updateListFilter(value, filters.fra));
    };

    return <SimpleCheckboxFilter id="origin" options={options ?? []} checked={filters.fra} onChange={onChange} />;
};
